<template>
    <div>
        <!-- payment methods start -->
        <CoCard>
            <CoText>
                You must activate all payment methods in Stripe before turning them on here.
                <a href="https://dashboard.stripe.com/settings/payment_methods" target="_blank"
                    >Stripe payment methods</a
                >
            </CoText>

            <CoFormGroup label="Card payments">
                <div class="d-flex align-items-center">
                    <CoSwitch
                        :value="form.Card"
                        v-model="form.Card"
                        :disabled="!form.CardActiveInBillingProvider || loading"
                    />
                    <CoText v-if="!form.CardActiveInBillingProvider && !loading" type="p3">
                        You must activate card payments in Stripe before turning them on here.
                    </CoText>
                </div>
            </CoFormGroup>
            <CoFormGroup label="SEPA">
                <div class="d-flex align-items-center">
                    <CoSwitch
                        :value="form.SEPA"
                        v-model="form.SEPA"
                        :disabled="!form.SEPAActiveInBillingProvider || loading"
                    />
                    <CoText v-if="!form.SEPAActiveInBillingProvider && !loading" type="p3">
                        You must activate SEPA payments in Stripe before turning them on here.
                    </CoText>
                </div>
            </CoFormGroup>
            <co-alert variant="grey" size="md">
                <CoText>
                    By default, SEPA direct debit transactions have a limit of EUR 10,000 each. For new customers, there
                    is an additional weekly total limit of EUR 10,000. For more information on SEPA payment limits, see
                    <a
                        href="https://help.coapp.io/en/articles/8519182-important-considerations-when-accepting-sepa-direct-debit-payments-for-memberships"
                        target="_blank"
                        title="Read the Help Article"
                        >'Important considerations when accepting SEPA direct debit payments for memberships'</a
                    >
                    in our Help Center.
                </CoText>
            </co-alert>
            <div class="d-flex justify-content-end mt-4">
                <CoButton
                    variant="primary"
                    type="button"
                    @click="setPaymentMethods"
                    :disabled="!isFormValid"
                    :loading="loading"
                    >{{ $t('labels.save') }}</CoButton
                >
            </div>
        </CoCard>
    </div>
</template>

<script>
import axios from 'axios';
import EventBus from '@/eventBus';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoSwitch from '@/components/Atoms/co-switch/CoSwitch.vue';

export default {
    name: 'PaymentMethods',
    components: { CoAlert, CoCard, CoFormGroup, CoSwitch, CoText, CoButton },
    data() {
        return {
            form: {
                Card: false,
                SEPA: false,
            },
            loading: false,
        };
    },
    computed: {
        isFormValid() {
            return this.form.Card || this.form.SEPA;
        },
    },
    mounted() {
        this.getPaymentMethods();
    },

    methods: {
        getPaymentMethods() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/admin/payment/stripe/payment-methods',
                withCredentials: true,
            })
                .then((response) => {
                    this.loading = false;
                    if (response && response.data) {
                        this.form = response.data;
                    }
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.failedGeneric'),
                        Details: error,
                    });
                    this.loading = false;
                });
        },

        setPaymentMethods() {
            if (!this.form.Card && !this.form.SEPA) {
                EventBus.$emit('ERROR', {
                    Message: this.$t('errors.atLeastOneMethod'),
                });
                return;
            }
            this.loading = true;
            axios({
                method: 'PUT',
                url: '/admin/payment/stripe/payment-methods',
                withCredentials: true,
                data: this.form,
            })
                .then((response) => {
                    this.loading = false;
                    EventBus.$emit('INFO', {
                        Message: this.$t('labels.changessaved'),
                    });
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.failedGeneric'),
                        Details: error,
                    });
                    this.loading = false;
                });
        },
    },
};
</script>
